import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, CanLoad, Route, UrlSegment, UrlTree } from '@angular/router';

// Auth Services
import { AuthService } from '../services/auth.service';
import { Observable, throwError } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class AgentGuard implements CanActivate {
  constructor(
    private router: Router,
    private authService: AuthService
  ) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    let entityData: any = localStorage.getItem('entityData');
    let isDemo = JSON.parse(entityData).isDemo;
    const currentUser: any = this.authService.currentUserValue;
    if (currentUser && (currentUser.role == 'AGENT') && !isDemo) {
      return this.authService.checkUser().pipe(
        map(data => true),
        catchError((err) => {
          this.authService.removeUserToLocalStorage();
          this.router.navigate(['/']);
          return throwError(false);
        })
      );
    } else {
      this.router.navigate(['/'])
      return throwError('Unauthorized Access');
    }
  }

}
